import type { SurveyConfig } from "@src/types/survey";

export const DEFAULT_SURVEY_CONFIG: SurveyConfig = {
    id: "speedtest-survey-v1",
    version: "1.0.0",
    timing: "after",
    steps: [
        {
            id: "flow-select",
            title: "Getting Started",
            description: "Tell us where you're testing from.",
            fields: [
                {
                    id: "flowType",
                    label: "Where are you testing from?",
                    type: "radio",
                    required: false,
                    options: [
                        { label: "School", value: "school" },
                        { label: "Home", value: "home" },
                    ],
                    colSpan: 2,
                },
            ],
        },
        {
            id: "identity",
            title: "Your Info",
            description: "Basic identification.",
            fields: [
                {
                    id: "name",
                    label: "Name",
                    type: "text",
                    placeholder: "Your name",
                    required: false,
                    autocomplete: "name",
                },
                {
                    id: "address",
                    label: "Address",
                    type: "address",
                    placeholder: "Type your address or tap the pin icon\u2026",
                    required: false,
                    colSpan: 2,
                },
            ],
        },
        {
            id: "provider",
            title: "Connection Info",
            description: "We've pre-filled what we can from your connection.",
            fields: [
                {
                    id: "provider",
                    label: "Internet Provider",
                    type: "text",
                    autoPopulate: { source: "ipInfo", path: "org" },
                    editable: true,
                    placeholder: "Edit if incorrect",
                    colSpan: 2,
                },
                {
                    id: "psuId",
                    label: "PSU ID",
                    type: "text",
                    autoPopulate: {
                        source: "lookedUpIp",
                        path: "row.Entity ID",
                    },
                    editable: true,
                    placeholder: "",
                    visibleWhen: {
                        field: "flowType",
                        operator: "eq",
                        value: "school",
                    },
                },
                {
                    id: "psuName",
                    label: "PSU / District Name",
                    type: "text",
                    autoPopulate: {
                        source: "lookedUpIp",
                        path: "row.Entity Name",
                    },
                    editable: true,
                    placeholder: "",
                    visibleWhen: {
                        field: "flowType",
                        operator: "eq",
                        value: "school",
                    },
                },
                {
                    id: "connectionType",
                    label: "Connection Type",
                    type: "select",
                    options: [
                        { label: "WiFi", value: "wifi" },
                        { label: "Ethernet", value: "ethernet" },
                        { label: "Cellular", value: "cellular" },
                        { label: "Satellite", value: "satellite" },
                        { label: "Other", value: "other" },
                    ],
                },
            ],
        },
        {
            id: "school-details",
            title: "School Details",
            description: "Information about your school.",
            flows: ["school"],
            fields: [
                {
                    id: "schoolName",
                    label: "School Name",
                    type: "text",
                    placeholder: "e.g., Lincoln Elementary",
                    required: false,
                },
                {
                    id: "schoolNumber",
                    label: "School Number",
                    type: "text",
                    placeholder: "e.g., 001",
                },
                {
                    id: "classroomName",
                    label: "Classroom Name",
                    type: "text",
                    placeholder: "e.g., Room 204",
                },
                {
                    id: "classroomNumber",
                    label: "Classroom Number",
                    type: "text",
                    placeholder: "e.g., 204",
                },
            ],
        },
        // home-details removed — connectionType moved to Connection Info step
        {
            id: "review",
            title: "Review",
            description: "Review your information before submitting.",
            fields: [],
        },
    ],
};
